var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showFullScreenMenu)?_c('full-screen-menu',{on:{"close":function($event){_vm.showFullScreenMenu = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }